import { Tag } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import type { UserBaseModel } from '../../features/tenant-manager/models';

type Props = {
  isIntegrated: z.infer<typeof UserBaseModel>['isIntegrated'];
};

export const GimaTag: FC<Props> = ({ isIntegrated }) => {
  const { t } = useTranslation();
  return isIntegrated ? (
    <Tag style={{ display: 'flex', alignItems: 'center' }}>
      {t('tag-label-gima')}
    </Tag>
  ) : null;
};
